/* Upsell carousel arrows and mouse drag.
   Our CSS neutralises UpCart's transform, so the arrows must scroll the
   window themselves. State is a class, not the disabled attribute, because a
   disabled button fires no click. */
(function () {
  'use strict';

  var HOST_ID = 'upCart';
  var GAP = 10;
  var DISABLED = 'sh-arrow--off';
  var THRESHOLD = 4;
  var FLICK = 40;

  function root() {
    var host = document.getElementById(HOST_ID);
    return (host && host.shadowRoot) || document;
  }

  function step(win) {
    var slide = win.querySelector('.upcart-public-component-carousel__slide');
    return slide ? slide.getBoundingClientRect().width + GAP : win.clientWidth;
  }

  function update(win, prev, next) {
    var atStart = win.scrollLeft <= 1;
    var atEnd = win.scrollLeft + win.clientWidth >= win.scrollWidth - 1;
    prev.classList.toggle(DISABLED, atStart);
    next.classList.toggle(DISABLED, atEnd);
  }

  // The stylesheet uses !important, so a plain inline style loses.
  function force(el, prop, value) {
    if (value) el.style.setProperty(prop, value, 'important');
    else el.style.removeProperty(prop);
  }

  function wire(btn, win, dir) {
    // UpCart re-adds this on every render. A disabled button fires no click,
    // so clear it every time, not only when the listener is attached.
    if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');

    if (btn.dataset.shArrow === '1') return;
    btn.dataset.shArrow = '1';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains(DISABLED)) return;
      win.scrollBy({ left: dir * step(win), behavior: 'smooth' });
    }, true);
  }

  // Mouse drag. A touch screen scrolls the window by itself; a mouse does not.
  function wireDrag(win) {
    if (win.dataset.shDrag === '1') return;
    win.dataset.shDrag = '1';

    var down = false;
    var dragging = false;
    var suppressClick = false;
    var startX = 0;
    var startLeft = 0;
    var dx = 0;
    var settle = null;

    // Snapping and smooth scrolling both fight a drag.
    function free() {
      force(win, 'scroll-snap-type', 'none');
      force(win, 'scroll-behavior', 'auto');
      force(win, 'user-select', 'none');
      win.style.cursor = 'grabbing';
    }

    function restore() {
      settle = null;
      force(win, 'scroll-snap-type', '');
      force(win, 'scroll-behavior', '');
      force(win, 'user-select', '');
      win.style.cursor = '';
    }

    // A short drag must still change the card, as a flick does on a phone.
    function land() {
      var w = step(win);
      var pos = w ? win.scrollLeft / w : 0;
      var target = Math.round(pos);

      if (Math.abs(dx) >= FLICK) {
        target = dx < 0 ? Math.ceil(pos) : Math.floor(pos);
      }
      if (target < 0) target = 0;

      win.scrollTo({ left: target * w, behavior: 'smooth' });
      if (settle) clearTimeout(settle);
      settle = setTimeout(restore, 400);
    }

    win.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (settle) { clearTimeout(settle); restore(); }
      down = true;
      dragging = false;
      suppressClick = false;
      dx = 0;
      startX = e.clientX;
      startLeft = win.scrollLeft;
    });

    win.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - startX;

      // Capture only after a real drag. An early capture steals the click
      // from the + button.
      if (!dragging) {
        if (Math.abs(dx) <= THRESHOLD) return;
        dragging = true;
        free();
        try { win.setPointerCapture(e.pointerId); } catch (err) {}
      }

      win.scrollLeft = startLeft - dx;
      e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;

      if (e && e.pointerId !== undefined && win.hasPointerCapture(e.pointerId)) {
        win.releasePointerCapture(e.pointerId);
      }
      if (!dragging) return;

      dragging = false;
      suppressClick = true;
      land();
    }

    win.addEventListener('pointerup', end);
    win.addEventListener('pointercancel', end);

    // block only the click that ends a drag, never a later one
    win.addEventListener('click', function (e) {
      if (!suppressClick) return;
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    win.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() {
    var r = root();
    var win = r.querySelector('.upcart-public-component-carousel__window');
    if (!win) return;

    wireDrag(win);

    var prev = r.querySelector('[aria-label="Previous slide"]');
    var next = r.querySelector('[aria-label="Next slide"]');
    if (!prev || !next) return;

    wire(prev, win, -1);
    wire(next, win, 1);

    if (win.dataset.shArrowScroll !== '1') {
      win.dataset.shArrowScroll = '1';
      win.addEventListener('scroll', function () { update(win, prev, next); });
    }

    update(win, prev, next);
  }

  var timer = null;
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(init, 120);
  }

  function start() {
    schedule();
    new MutationObserver(schedule)
      .observe(document.documentElement, { childList: true, subtree: true });

    var host = document.getElementById(HOST_ID);
    if (host && host.shadowRoot) {
      new MutationObserver(schedule)
        .observe(host.shadowRoot, { childList: true, subtree: true });
    }

    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
